import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}
export interface Saperator {
  name: string;
  type?: string;
}
export interface SubChildren {
  state: string;
  name: string;
  type?: string;
}
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  child?: SubChildren[];
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  saperator?: Saperator[];
  children?: ChildrenItems[];
}

const MENUITEMS = [
  {
    state: 'careplan',
    name: 'Dashboard',
    type: 'link',
    icon: 'dashboard',
    key: 'dashboard'
  },
  {
    state: 'message',
    name: 'Messages',
    type: 'link',
    icon: 'message',
    key: 'messages'
  },
  {
    state: 'book-appointment',
    name: 'Appointment',
    type: 'link',
    icon: 'av_timer',
    key: 'appointment'
  },
  {
    state: 'care-rewards',
    name: 'Care Rewards',
    type: 'link',
    icon: 'emoji_events',
    key: 'care_rewards'
  },
  {
    state: 'my-profile',
    name: 'Personal Information',
    type: 'link',
    icon: 'assignment_ind',
    key: 'personal_information'
  }
];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
